import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          片库更新、功能升级与平台快讯
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300/60">
            {updatesData.map((item, i) => (
              <div key={item.id} className={`relative pb-8 ${i === updatesData.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-100"></div>
                <span className="text-xs text-foreground-400 mb-1 block">{item.date}</span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}